import { type ReactNode, createContext, useContext, useEffect, useState } from 'react'

import { useAiChat as useF0AiChat, type ClarifyingQuestionState } from '@factorialco/f0-react'

type ClarifyingQuestionContextValue = {
  clarifyingQuestion: ClarifyingQuestionState | null
  setClarifyingQuestion: React.Dispatch<React.SetStateAction<ClarifyingQuestionState | null>>
}

const ClarifyingQuestionContext = createContext<ClarifyingQuestionContextValue | null>(null)

const NO_PROVIDER_FALLBACK: ClarifyingQuestionContextValue = {
  clarifyingQuestion: null,
  setClarifyingQuestion: () => {},
}

export const ClarifyingQuestionProvider = ({ children }: { children: ReactNode }) => {
  const [clarifyingQuestion, setClarifyingQuestion] = useState<ClarifyingQuestionState | null>(null)

  return (
    <ClarifyingQuestionContext.Provider value={{ clarifyingQuestion, setClarifyingQuestion }}>
      {children}
    </ClarifyingQuestionContext.Provider>
  )
}

// Must render inside `ApplicationFrame` so `setIsClarifying` reaches the
// real f0 provider rather than the no-op fallback.
export const ClarifyingQuestionSyncer = () => {
  const { clarifyingQuestion } = useClarifyingQuestion()
  const { setIsClarifying } = useF0AiChat()

  useEffect(() => {
    setIsClarifying(clarifyingQuestion !== null)
  }, [clarifyingQuestion, setIsClarifying])

  return null
}

export function useClarifyingQuestion(): ClarifyingQuestionContextValue {
  return useContext(ClarifyingQuestionContext) ?? NO_PROVIDER_FALLBACK
}
